<div [formGroup]="group" [attr.class]="styleForm">
    <label *ngIf="label" [attr.for]="controlName">{{ label }}</label>
    <div [class.has-icon]="icon" class="field">
        <i *ngIf="icon" [attr.class]="icon"></i>
        <!-- <input type="text" class="field" [formControlName]="controlName" [attr.placeholder]="placeholder" #field (blur)="onBlur(field.value)"> -->
        <p-chipstab
            [formControlName]="controlName"
            (onAdd)="addUpper($event)"
            (onRemove)="removeChip($event)"
            [placeholder]="placeholder"
            [excludeValue]="excludeValue"
            [addOnBlur]="true"
            [osmanClass]="osmanClass"></p-chipstab>
    </div>
</div>
